/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import store from 'store'
import { useFormik } from 'formik'

import { mediaService, productService } from 'services'
import { brandsService } from 'services/brand.service'

import { _object } from 'utils/interfaces'
import 'react-quill/dist/quill.snow.css'
import ReactQuill from 'react-quill'
import { toast } from 'react-toastify'
import { Button, InputField } from 'components/form-inputs'
import { DeleteIcon, Emptystar, Fillstar } from 'assets/svg'

const EditProduct = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const [product, setProduct] = useState<_object>({})
  const [brands, setBrands] = useState<_object>({})
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [isUploading, setIsUploading] = useState(false);
  const [loading, setLoading] = useState(false)
  const [loadingId, setLoadingId] = useState<string | null>(null);
  const getProductDetails = () => {
    productService.getProductDetails(id).then((results: _object) => {
      setProduct(results)
    })
  }
  useEffect(() => {
    getProductDetails()
  }, [id])

  useEffect(() => {
    brandsService.getBrands({ per_page: 999 }).then((results: _object) => {
      setBrands(results)
    })
  }, [])

  // const validationSchema = Yup.object({
  //   brand_id: Yup.string()
  //     .required('Brand is required'),

  //   product_info: Yup.string()
  //     .required('Product info is required'),

  //   description: Yup.string()
  //     .required('Description is required'),

  //   product_specifications: Yup.string()
  //     .required('Product specifications are required'),

  //   featured: Yup.boolean()
  //     .required('Featured is required'),

  //   units_per_carton: Yup.number()
  //     .typeError('Units per carton must be a number')
  //     .integer('Must be an integer')
  //     .min(1, 'Must be at least 1')
  //     .required('Units per carton is required')
  // });

  const formik: _object = useFormik({
    initialValues: {
      brand_id: product?.brand_id,
      product_info: product?.product_info || '',
      description: product?.description || '',
      product_specifications: product?.product_specifications || '',
      featured: product?.featured || false,
      units_per_carton: product?.units_per_carton || 2,
      display_on_ecom: product?.display_on_ecom || false,
      new_title: product?.new_title || ''
    },
    enableReinitialize: true,
    // validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      productService.updateProduct(id, values).then((results: _object) => {
        if (results.error == false) {
          navigate('/app/products')
        }
        setLoading(false)
      })
    }
  })

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null
    if (file) {
      setSelectedFile(file)
    }
  }

  useEffect(() => {
    if (!selectedFile) return;
    setIsUploading(true);
    const uploadImage = async () => {

      const data = new FormData();
      if (id) {
        data.append('entity_id', id)
      }
      data.append('entity_type', 'product');
      data.append('key', 'product_image');
      data.append('files', selectedFile);
      const accessToken = store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || '');

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/media`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: accessToken ? accessToken : '',
        },
        body: data,
      });

      const result = await response.json();
      if (result.error === false) {
        getProductDetails()
        toast.success(result.message || 'Image uploaded successfully.', {
          autoClose: 3000,
        });
      }
      else if (result.error === true) {
        toast.error(result.message || 'Image not uploaded.', {
          autoClose: 3000,
        });
      }
      setIsUploading(false);
      getProductDetails()
    };

    uploadImage();
  }, [selectedFile]);

  const [selectedId, setSelectedId] = useState<string | null>(null);
  const featuredImage = (id: string) => {
    setLoadingId(id);
    setSelectedId(id);
    mediaService.upDateMediaData(id, {
      sequence: 1,
    }).then((results: _object) => {
      console.log("results", results);
    }).finally(() => {
      setLoadingId(null);
      getProductDetails()
    });
  }


  const handleDeleteProduct = (id: string) => {
    const confirmed = window.confirm("Are you sure you want to delete ?");
    if (!confirmed) return;

    mediaService.deleteMediaData(id).then((results: _object) => {
      if (results.error === false) {
        getProductDetails();
      }
    });
  };


  return (
    <>
      <div className="mb-6">
        <h1 className="mb-1 text-2xl font-semibold">
          {product?.title} <small className="block">SKU: {product?.sku}</small>
        </h1>
      </div>
      <div className="grid grid-cols-2">
        <div className="flex flex-col gap-4">
          <form onSubmit={formik.handleSubmit}>
            <div className='mb-4'>
              <InputField
                label='New Title'
                placeholder='New Title'
                name='new_title'
                onChange={formik.handleChange}
                value={formik.values.new_title}
              />
            </div>
            <div className="mb-4">
              <InputField
                label='Units per carton'
                type="number"
                name="units_per_carton"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.units_per_carton}
                placeholder='Units per carton'
              // min={2}
              />
            </div>
            <div className="mb-4">
              <label className="mb-2 block text-sm font-medium text-gray-900">
                Featured <span className="text-red-500">*</span>
              </label>
              <div className="flex items-center gap-4 text-sm">
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="featured"
                    value="true"
                    checked={formik.values.featured === true || formik.values.featured === 'true'}
                    onChange={() => formik.setFieldValue('featured', true)}
                  />
                  Yes
                </label>
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="featured"
                    value="false"
                    checked={formik.values.featured === false || formik.values.featured === 'false'}
                    onChange={() => formik.setFieldValue('featured', false)}
                  />
                  No
                </label>
              </div>
            </div>


            <div className="mb-4">
              <label className="mb-2 block text-sm font-medium text-gray-900">
                Display On Ecom <span className="text-red-500">*</span>
              </label>
              <div className="flex items-center gap-4 text-sm">
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="display_on_ecom"
                    value="true"
                    checked={formik.values.display_on_ecom === true || formik.values.display_on_ecom === 'true'}
                    onChange={() => formik.setFieldValue('display_on_ecom', true)}
                  />
                  Yes
                </label>
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="display_on_ecom"
                    value="false"
                    checked={formik.values.display_on_ecom === false || formik.values.display_on_ecom === 'false'}
                    onChange={() => formik.setFieldValue('display_on_ecom', false)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="mb-4">
              <label htmlFor="brand" className="mb-2 block text-sm font-medium text-gray-900">
                Brand <span className="text-red-500">*</span>
              </label>
              <select
                id="brand"
                name="brand_id"
                value={formik.values.brand_id}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="block w-full appearance-none rounded-md border bg-white px-3 py-2 pr-10 text-sm outline-none focus:outline-none"
              >
                <option value="">Select a brand</option>
                {brands?.items?.map((item: _object, i: number) => (
                  <option key={i} value={item.id}>
                    {item.title}
                  </option>
                ))}
              </select>

            </div>
            <div className="mb-4">
              <label
                htmlFor="product_info"
                className="mb-2 block text-sm font-medium text-gray-900"
              >
                Product Information <span className="text-red-500">*</span>
              </label>
              <ReactQuill
                id="product_info"
                value={formik.values.product_info}
                onChange={(value: string) => formik.setFieldValue('product_info', value || '')}
                className="w-full text-sm outline-none focus:outline-none"
                placeholder="Product Information"
              />
            </div>

            <div className="mb-4">
              <label htmlFor="description" className="mb-2 block text-sm font-medium text-gray-900">
                Product Description <span className="text-red-500">*</span>
              </label>
              <ReactQuill
                id="description"
                value={formik.values.description}
                onChange={(value: string) => formik.setFieldValue('description', value || '')}
                // onBlur={formik.handleBlur}
                className="w-full text-sm outline-none focus:outline-none"
                placeholder="Product Description"
              />
            </div>

            <div className="mb-4">
              <label
                htmlFor="product_specifications"
                className="mb-2 block text-sm font-medium text-gray-900"
              >
                Specifications Table <span className="text-red-500">*</span>
              </label>
              <ReactQuill
                id="product_specifications"
                value={formik.values.product_specifications}
                onChange={(value: string) =>
                  formik.setFieldValue('product_specifications', value || '')
                }
                // onBlur={formik.handleBlur}
                className="w-full text-sm outline-none focus:outline-none"
                placeholder="Product Specification"
              />
            </div>

            <Button
              label="Save changes"
              type="submit"
              className="cursor mt-4 flex w-full justify-center rounded-lg bg-purple-900 py-2 text-center text-sm text-white transition hover:bg-purple-950 disabled:opacity-50"
              loading={loading}
              disabled={!formik.isValid || !formik.dirty}
            />
          </form>
        </div>

        <div className="p-5">
          <h3 className="mb-1 text-sm font-medium text-gray-900">Product Images </h3>
          <h3 className="mb-2 text-[10px] text-[#969494] font-medium">221W × 221H | 1:1 </h3>
          <div className="flex flex-wrap gap-4">

            {product?.media?.map((item: _object, i: number) => {
              // Show * if selected or default to first item
              const showStar = selectedId === item.id || (selectedId === null && i === 0);

              return (
                <div
                  className="relative w-32 h-32 cursor-pointer group"
                  key={i}
                >
                  {/* Top-right black strip with icons (only visible on hover) */}
                  <div className="absolute top-0 right-0 
                      w-[55px] rounded-md 
                      flex justify-between items-center 
                      px-2 py-1 
                      bg-white bg-opacity-70 
                      z-20 opacity-0 
                      border border-transparent 
                      group-hover:opacity-100 
                      group-hover:border-gray-400 
                      transition-all duration-200
                      ">
                    {/* Delete icon */}
                    <button
                      type="button"
                      onClick={() => handleDeleteProduct(item.id)}
                      className="text-white"
                      title="Delete this media"
                    >
                      {/* <DeleteIcon className="w-4 h-4 text-purple-900" /> */}

                      <svg
                        version="1.1"
                        width="18"
                        height="18"
                        x="0"
                        y="0"
                        viewBox="0 0 21 21"
                        xmlSpace="preserve"
                        fillRule="evenodd"
                      >
                        <g>
                          <g fill="#581c87" fillRule="nonzero">
                            <path
                              d="M17.741 3.599v.012l-.002.035v.005l-.923 14.522c-.03.483-.235.925-.553 1.244a1.723 1.723 0 0 1-1.23.513h-9.15c-.486 0-.916-.196-1.233-.513a1.92 1.92 0 0 1-.55-1.248L3.26 3.648v-.039l-.001-.023v-.029a.418.418 0 0 1 .414-.421h.004v-.002h13.647a.42.42 0 0 1 .418.465zM15.98 18.12l.9-14.146H4.119l.818 14.15c.016.273.13.521.307.699a.897.897 0 0 0 .639.268h9.15c.25 0 .471-.103.636-.267.178-.18.293-.43.31-.704z"
                              fill=""
                              opacity="1"
                            ></path>
                            <path
                              d="M1.472 3.974a.42.42 0 0 1 0-.84H19.53a.42.42 0 0 1 0 .84z"
                              fill=""
                              opacity="1"
                            ></path>
                            <path
                              d="M8.05 1.047h4.902c.333 0 .637.137.858.357l.001.002h.001c.22.221.356.525.356.857v1.291a.42.42 0 0 1-.42.42H7.253a.42.42 0 0 1-.42-.42V2.263c0-.333.136-.637.357-.857v-.001l.001-.001.001-.001c.221-.22.525-.356.857-.356zm4.902.84H8.049a.374.374 0 0 0-.265.11h-.002a.374.374 0 0 0-.11.266v.871h5.656v-.87a.374.374 0 0 0-.109-.266l-.002-.002a.374.374 0 0 0-.265-.11zM7.267 6.443a.42.42 0 0 1 .84 0v10.179a.42.42 0 0 1-.84 0zM10.08 6.443a.42.42 0 0 1 .84 0v10.179a.42.42 0 0 1-.84 0zM12.894 6.443a.42.42 0 0 1 .84 0v10.179a.42.42 0 0 1-.84 0z"
                              fill=""
                              opacity="1"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </button>

                    {/* Hover-only star icon for non-featured items */}
                    {!showStar && (
                      <span className="text-white absolute top-0 right-0 text-purple-900 z-30 pr-1 pt-[2px]" title='Select this media' onClick={() => featuredImage(item.id)}><svg

                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        width="20"
                        height="20"
                        x="0"
                        y="0"
                        viewBox="0 0 512 512"
                        xmlSpace="preserve"
                        fillRule="evenodd"
                        className=""
                      >
                        <g>
                          <path
                            fill="#581c87"
                            d="m3 187-1-1h179v-1h1l10-24L256 2v1-1l64 159 10 24h180s-1 1-1 2c-16 17-151 115-151 115l59 185h-5l-7-3c-29-16-143-84-143-84l-162 87h-5l59-185S18 204 3 187zm394 272-87-173 121-72-138 8-38-119-38 119-138-8 121 72-80 168 142-104 134 109z"
                            opacity="1"
                            data-original="#581c87"
                            className=""
                          ></path>
                        </g>
                      </svg></span>
                    )}
                  </div>

                  {/* Always-visible star icon for featured image */}
                  {showStar && (
                    <span className="absolute top-0 right-0 text-purple-900 z-30 pr-1">

                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18" height="24" x="0" y="0" viewBox="0 0 512 512"><g><path d="m512 197.816-186.039-12.231L255.898 9.569l-70.063 176.016L0 197.816l142.534 121.026-46.772 183.589L255.898 401.21l160.137 101.221-46.772-183.589z" fill="#581c87" opacity="1" data-original="#000000"></path></g></svg>


                    </span>
                  )}

                  {/* Image box */}
                  <div
                    className="flex h-full w-full items-center justify-center rounded-md bg-gray-100 shadow relative"

                  >
                    <img
                      src={item?.path}
                      alt={`shirt${i + 1}`}
                      className="h-24 w-24 object-contain"
                    />

                    {/* Spinner overlay */}
                    {loadingId === item.id && (
                      <div className="absolute inset-0 flex items-center justify-center bg-white/60 rounded-md z-20">
                        <svg
                          aria-hidden="true"
                          className="w-6 h-6 text-gray-300 animate-spin fill-blue-600"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          {/* spinner paths */}
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}

            <label htmlFor="imageUpload">
              <div className="flex h-32 w-32 cursor-pointer items-center justify-center rounded-md border-2 border-dashed border-purple-900">
                <input
                  type="file"
                  id="imageUpload"
                  accept=".png, .jpg, .jpeg"
                  onChange={handleImageChange}
                  className="hidden"
                />
                {isUploading ? (
                  <svg
                    className="h-8 w-8 animate-spin text-purple-900"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                ) : (
                  <span className="text-4xl font-bold text-purple-900">+</span>
                )}
              </div>
            </label>

          </div>
        </div>
      </div>
    </>
  )
}

export default EditProduct
